import Vue from 'vue'
import Router from 'vue-router'
import register from '@/components/register/register'
import login from '@/components/login/login'
import verification from '@/components/verification/verification'
import evaluation from '@/components/evaluation/evaluation'
import test from '@/components/test/test'
import topic from '@/components/topic/topic'
import speak from '@/components/speak/speak'
import vocabulary from '@/components/vocabulary/vocabulary'
import complete from '@/components/complete/complete'
import read from '@/components/read/read'
import sight from '@/components/sight/sight'
import put from '@/components/put/put'
import detail from '@/components/detail/detail'
import orderconfirm from '@/components/orderconfirm/orderconfirm'
import success from '@/components/success/success'
import group from '@/components/group/group'
import groupsuccess from '@/components/groupsuccess/groupsuccess'
import description from '@/components/description/description'
import tutorial from '@/components/tutorial/tutorial'
import index from '@/components/index/index'
import capterdetail from '@/components/capterdetail/capterdetail'
import jindukecheng from '@/components/jindukecheng/jindukecheng'
import taoshu from '@/components/taoshu/taoshu'
import book from '@/components/book/book'
import detail2 from '@/components/detail2/detail2'
import entercode from '@/components/entercode/entercode'
import achievement from '@/components/achievement/achievement'
import mine from '@/components/mine/mine'
import leaderboard from '@/components/leaderboard/leaderboard'
import selectcity from '@/components/selectcity/selectcity'
import userinfo from '@/components/userinfo/userinfo'
import jiangzhuang from '@/components/jiangzhuang/jiangzhuang'
import studycenter from '@/components/studycenter/studycenter'
import order from '@/components/order/order'
import orderdetail from '@/components/orderdetail/orderdetail'
import ordercommit from '@/components/ordercommit/ordercommit'
import coin from '@/components/coin/coin'
import integralshop from '@/components/integralshop/integralshop'
import integralshopdetail from '@/components/integralshopdetail/integralshopdetail'
import address from '@/components/address/address'
import addresslist from '@/components/addresslist/addresslist'
import integraldetail from '@/components/integraldetail/integraldetail'
import integralhistory from '@/components/integralhistory/integralhistory'
import integralhistorydetail from '@/components/integralhistorydetail/integralhistorydetail'
import conpon from '@/components/conpon/conpon'
import interactive from '@/components/interactive/interactive'
import feedback from '@/components/feedback/feedback'
import vipcenter from '@/components/vipcenter/vipcenter'
import vipdescription from '@/components/vipdescription/vipdescription'
import aboutus from '@/components/aboutus/aboutus'
import chongdingxiang from '@/components/chongdingxiang/chongdingxiang'
import audiolist from '@/components/audiolist/audiolist'
import audiodetail from '@/components/audiodetail/audiodetail'
import missing from '@/components/missing/missing'
import guanzhu from '@/components/guanzhu/guanzhu'



Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/register',
      name: 'register',
      component: register,
      meta:{
        title:'注册登录'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{
        title:'登录'
      }
    },
    {
      path: '/verification',
      name: 'verification',
      component: verification,
      meta:{
        title:'验证'
      }
    },
    {
      path: '/evaluation',
      name: 'evaluation',
      component: evaluation,
      meta:{
        title:'测评'
      }
    },
    {
      path: '/test',
      name: 'test',
      component: test,
      meta:{
        title:'Alphabet Explorer'
      },
    },
    {
      path: '/topic/know',
      name: 'know',
      component: topic,
      meta:{
        title:'Test 1:I know It'
      },
    },
    {
      path: '/topic/speak',
      name: 'speak',
      component: speak,
      meta:{
        title:'Test 2:I Can Speak'
      },
    },
    {
      path: '/topic/vocabulary',
      name: 'vocabulary',
      component: vocabulary,
      meta:{
        title:'Test 3:My Vocabulary'
      },
    },
    {
      path: '/topic/read',
      name: 'read',
      component: read,
      meta:{
        title:'Test3:I can Read'
      },
    },
    {
      path: '/topic/sight',
      name: 'sight',
      component: sight,
      meta:{
        title:'Test 2_Sight Words'
      },
    },
    {
      path: '/topic/put',
      name: 'put',
      component: put,
      meta:{
        title:'Test3:Put it in Order'
      },
    },
    {
      path: '/topic/missing',
      name: 'missing',
      component: missing,
      meta:{
        title:'Test3:Put it in Order'
      },
    },
    {
      path: '/complete',
      name: 'complete',
      component: complete,
      meta:{
        title:'Alptabet Explorer'
      },
    },
    {
      path: '/complete/:type',
      name: 'complete',
      component: complete,
      meta:{
        title:'Alptabet Explorer'
      },
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: detail,
      meta:{
        title:'课程详情'
      },
    },
    {
      path: '/order/confirm',
      name: 'orderconfirm',
      component: orderconfirm,
      meta:{
        title:'确认订单'
      },
    },
    {
      path: '/pay/success',
      name: 'success',
      component: success,
      meta:{
        title:'购买成功'
      },
    },
    {
      path: '/group',
      name: 'group',
      component: group,
      meta:{
        title:'开团成功'
      },
    },
    {
      path: '/group/success',
      name: 'groupsuccess',
      component: groupsuccess,
      meta:{
        title:'开团成功'
      },
    },
    {
      path: '/description',
      name: 'description',
      component: description,
      meta:{
        title:'服务说明'
      },
    },

    {
      path: '/',
      name: 'index',
      component: index,
      redirect:'/tutorial',
      children:[
        {
          path: 'tutorial',
          name: 'tutorial',
          component: tutorial,
          meta:{
            title:'盖世'
          },
        },
        {
          path: 'mine',
          name: 'mine',
          component: mine,
          meta:{
            title:'排行榜'
          },
        },

      ]
    },
    {
      path: '/capter/detail',
      name: 'capterdetail',
      component: capterdetail,
      meta:{
        title:'章节详情'
      },
    },
    {
      path: '/jindukecheng',
      name: 'jindukecheng',
      component: jindukecheng,
      meta:{
        title:'精读课程'
      },
    },
    {
      path: '/taoshu',
      name: 'taoshu',
      component: taoshu,
      meta:{
        title:'精读课程'
      },
    },
    {
      path: '/book',
      name: 'book',
      component: book,
      meta:{
        title:'课程名称'
      },
    },
    {
      path: '/detail2',
      name: 'detail2',
      component: detail2,
      meta:{
        title:'课程详情'
      },
    },
    {
      path: '/entercode',
      name: 'entercode',
      component: entercode,
      meta:{
        title:'兑换码'
      },
    },
    {
      path: '/achievement',
      name: 'achievement',
      component: achievement,
      meta:{
        title:'My Achievement'
      },
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      component: leaderboard,
      meta:{
        title:'排行榜'
      },
    },
    {
      path: '/selectcity',
      name: 'selectcity',
      component: selectcity,
      meta:{
        title:'选择城市'
      },
    },
    {
      path: '/userinfo',
      name: 'userinfo',
      component: userinfo,
      meta:{
        title:'个人信息'
      },
    },
    {
      path: '/jiangzhuang',
      name: 'jiangzhuang',
      component: jiangzhuang,
      meta:{
        title:'奖状'
      },
    },
    {
      path: '/studycenter',
      name: 'studycenter',
      component: studycenter,
      meta:{
        title:'学习中心'
      },
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      meta:{
        title:'课程订单'
      },
    },
    {
      path: '/order/detail',
      name: 'orderdetail',
      component: orderdetail,
      meta:{
        title:'课程订单'
      },
    },
    {
      path: '/order/commit',
      name: 'ordercommit',
      component: ordercommit,
      meta:{
        title:'评价'
      },
    },
    {
      path: '/mine/coin',
      name: 'coin',
      component: coin,
      meta:{
        title:'评价'
      },
    },
    {
      path: '/mine/coin/integralshop',
      name: 'integralshop',
      component: integralshop,
      meta:{
        title:'评价'
      },
    },
    {
      path: '/mine/coin/integralshop/detail',
      name: 'integralshopdetail',
      component: integralshopdetail,
      meta:{
        title:'评价'
      },
    },
    {
      path: '/mine/coin/detail',
      name: 'integraldetail',
      component: integraldetail,
      meta:{
        title:'我的积分'
      },
    },
    {
      path: '/mine/coin/history',
      name: 'integralhistory',
      component: integralhistory,
      meta:{
        title:'兑换记录'
      },
    },
    {
      path: '/mine/coin/history/detail',
      name: 'integralhistorydetail',
      component: integralhistorydetail,
      meta:{
        title:'兑换记录'
      },
    },


    {
      path: '/address',
      name: 'address',
      component: address,
      meta:{
        title:'收货地址'
      },
    },
    {
      path: '/addresslist',
      name: 'addresslist',
      component: addresslist,
      meta:{
        title:'收货地址'
      },
    },
    {
      path: '/mine/conpon',
      name: 'conpon',
      component: conpon,
      meta:{
        title:'优惠券'
      },
    },
    {
      path: '/mine/interactive',
      name: 'interactive',
      component: interactive,
      meta:{
        title:'家长互动'
      },
    },
    {
      path: '/mine/feedback',
      name: 'feedback',
      component: feedback,
      meta:{
        title:'意见反馈'
      },
    },
    {
      path: '/mine/vipcenter',
      name: 'vipcenter',
      component: vipcenter,
      meta:{
        title:'会员中心'
      },
    },
    {
      path: '/mine/vipcenter/description',
      name: 'vipdescription',
      component: vipdescription,
      meta:{
        title:'说明'
      },
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus,
      meta:{
        title:'关于我们'
      },
    },
    {
      path: '/chongdingxiang',
      name: 'chongdingxiang',
      component: chongdingxiang,
      meta:{
        title:'重定向'
      },
    },
    {
      path: '/audio/list',
      name: 'audiolist',
      component: audiolist,
      meta:{
        title:'分类标题'
      },
    },
    {
      path: '/audio/detail/:id',
      name: 'audiodetail',
      component: audiodetail,
      meta:{
        title:'分类标题'
      },
    },
    {
      path: '/guanzhu',
      name: 'guanzhu',
      component: guanzhu,
      meta:{
        title:'关注我们'
      },
    },
    {
      path: '/caozuoshiping',
      name: 'caozuoshiping',
      component: ()=>import('@/components/caozuoshiping/caozuoshiping'),
      meta:{
        title:'操作视频'
      },
    },


    {
      path:'*',
      redirect:'/tutorial'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js